import React from 'react';
import classNames from 'classnames';

import 'components/home/home.scss';

interface HomeProps {
  title: string;
  subTitle: string;
  content: string;
  children?: any;
}

const Home: React.SFC<HomeProps> = props => (
  <div className={classNames('c-home o-wrapper o-wrapper--large')}>
    <h1 className={classNames('c-home__title')}>{props.title}</h1>
    <h2 className={classNames('c-home__subtitle')}>{props.subTitle}</h2>
    <p className={classNames('c-home__lead-text')}>{props.content}</p>
    {props.children}
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/components/home/home.tsx